jQuery(document).ready(function ($) {
    $('#input_11_13').attr('maxlength', '9');

    $('#input_11_13').on('input', function() {
        var form = $('#gform_11');
        var submit_button = $('#gform_submit_button_11');
        var $input_field = $(this);
        var pattern = /^[0-9\-]{7,9}$/;
        var $validation_message = $('#validation_message_11_13');
        var is_valid_field = true;

        $validation_message.remove();

        if ($input_field.val() !== '') {
            if (!pattern.test($input_field.val())) {
                is_valid_field = false;

                $input_field
                    .attr('aria-invalid', 'true')
                    .closest('.gfield')
                    .addClass('gfield_error')
                    .append('<div id="validation_message_11_13" class="gfield_description validation_message gfield_validation_message">Ange ett giltigt medlemsnummer, 7-9 tecken.</div>');
            } else {
                is_valid_field = true;
                $input_field
                    .removeAttr('aria-invalid')
                    .closest('.gfield')
                    .removeClass('gfield_error');
            }
        } else {
            is_valid_field = true;
            $input_field
                .removeAttr('aria-invalid')
                .closest('.gfield')
                .removeClass('gfield_error');
        }

        if (is_valid_field) {
            submit_button.prop('disabled', false);
        } else {
            submit_button.prop('disabled', true);
        }
    });
});
